import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api, { CATEGORY_LABELS } from "../lib/api";
import ProductCard from "../components/ProductCard";

const CATS = ["all", "honey", "cider", "maple-syrup", "wine", "apparel"];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const active = params.get("category") || "all";
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const q = active === "all" ? {} : { category: active };
    api.get("/products", { params: q }).then((r) => {
      setProducts(r.data);
      setLoading(false);
    });
  }, [active]);

  const setCat = (c) => {
    if (c === "all") setParams({});
    else setParams({ category: c });
  };

  return (
    <div className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto py-14 md:py-20">
      <div className="text-center mb-10">
        <p className="kicker">The Farm Store</p>
        <h1 className="font-serif text-5xl sm:text-6xl text-[#2D372B] mt-2 tracking-tight">Our Goods</h1>
      </div>

      <div className="flex flex-wrap justify-center gap-2 mb-12">
        {CATS.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c}`}
            onClick={() => setCat(c)}
            className={`uppercase tracking-widest text-xs px-5 py-2.5 rounded-sm border transition-colors ${
              active === c
                ? "bg-[#2D372B] text-white border-[#2D372B]"
                : "bg-transparent text-[#4A5D4E] border-[#E6DFD3] hover:border-[#B85C38] hover:text-[#B85C38]"
            }`}
          >
            {c === "all" ? "All" : CATEGORY_LABELS[c]}
          </button>
        ))}
      </div>

      {loading ? (
        <p className="text-center text-[#7C897B]">Loading…</p>
      ) : products.length === 0 ? (
        <p className="text-center text-[#7C897B]">No goods here yet — check back soon.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="product-grid">
          {products.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
